import { ERROR_CODES } from '@dealstack/shared/lib/common/errors';
import { getBackendErrorCode } from '@dealstack/frontend/shared/dataExchange/services/backendCodedError';

export const isInvestorSyncDownloadLimitError = (error: unknown): boolean =>
	getBackendErrorCode(error) === ERROR_CODES.PROJECT.MIP.MANAGE.INVESTORS[11020102];
